import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import styles from "./acceptInvitation.module.scss";
import Button from "src/components/button";
import { useDispatch } from "react-redux";
import {
  fetchingUserInvitation,
  registerInvitedUser,
  userActivation,
} from "src/redux/actions/users";
import { useSelector } from "react-redux";
import _ from "lodash";
import cx from "classnames";

function AcceptInvitation() {
  const dispatch = useDispatch();

  const { id } = useParams() as { id: string };
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const key = searchParams.get("key") as string;

  useEffect(() => {
    dispatch(fetchingUserInvitation({ id: id, key: key }));
  }, []);

  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    password: "",
    terms: false,
  });

  const [error, setError] = useState({
    firstName: "",
    password: "",
    terms: "",
  });

  const [loading, setLoading] = useState(false);
  const [successView, setSuccessView] = useState(false);

  const invitation = useSelector((state) =>
    _.get(state, "users.invitation.item"),
  ) as any;

  const invitationErrorCode = useSelector((state) =>
    _.get(state, "users.invitation.error.code"),
  ) as any;

  const invitationErrorMessage = useSelector((state) =>
    _.get(state, "users.invitation.error.message"),
  ) as any;

  const invitationLoading = useSelector((state) =>
    _.get(state, "users.invitation.loading"),
  );

  const registration = useSelector((state) =>
    _.get(state, "users.registration.item"),
  );

  useEffect(() => {
    if (registration) {
      setSuccessView(true);
    }
  }, [registration]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
    if (name in error) {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!user.firstName) {
      setError((prev) => ({
        ...prev,
        firstName: "First name cannot be empty",
      }));
      return;
    }
    if (!_.get(invitation, "ssoLoginMandatory", false) && _.size(_.get(user, "password")) < 8) {
      setError((prev) => ({
        ...prev,
        password: "Password should be at least 8 characters",
      }));
      return;
    }
    if (!user.terms) {
      setError((prev) => ({
        ...prev,
        terms: "Please accept terms and conditions",
      }));
      return;
    }

    setError({ firstName: "", password: "", terms: "" });
    setLoading(true);

    // dispatch(userActivation({ id: id, activationKey: key }));
    dispatch(
      registerInvitedUser({
        id: id,
        firstName: user.firstName,
        lastName: user.lastName,
        password: user.password,
        email: invitation.email,
      }),
    );
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };

  return (
    <div className={styles.activationContainer}>
      <img
        src="/images/Paperflite.png"
        alt="Paperflite Logo"
        className={styles.logo}
      />
      {!invitationLoading && (
        <>
          <h1 className={styles.title}>
            {successView ? (
              <>
                Account activated successfully!
                <p className={styles.signIn}>
                  Continue to{" "}
                  <a href="/public/login">
                    <span className={styles.signInText}>sign in</span>
                  </a>
                  ?
                </p>
              </>
            ) : (
              <>
                {invitationErrorCode != null ? (
                  <>
                    Unable to activate invitation.
                    <p className={styles.signIn}>{invitationErrorMessage}</p>
                  </>
                ) : (
                  "Please enter details for your account"
                )}
              </>
            )}
          </h1>
          {invitationErrorCode == null && !successView && (
            <form
              noValidate
              autoComplete="off"
              className={styles.activateForm}
              onSubmit={handleSubmit}
              onKeyDown={handleKeyPress}
            >
              <input
                readOnly
                className={styles.input}
                type="text"
                name="email"
                placeholder="Email"
                value={invitation?.email}
              />
              <input
                className={styles.input}
                type="text"
                name="firstName"
                placeholder="First Name"
                value={user.firstName}
                onChange={handleChange}
              />
              {error.firstName && (
                <p className={styles.error}>
                  <i className="paperflite-danger"></i>
                  <label>{error.firstName}</label>
                </p>
              )}
              <input
                className={styles.input}
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={user.lastName}
                onChange={handleChange}
              />
              {!_.get(invitation, "ssoLoginMandatory", false) && <input
                className={styles.input}
                type="password"
                name="password"
                placeholder="Set password"
                value={user.password}
                autoComplete="new-password"
                onChange={handleChange}
              />}
              {error.password && (
                <p className={styles.error}>
                  <i className="paperflite-danger"></i>
                  <label>{error.password}</label>
                </p>
              )}
              <div className={styles.subText}>
                <i
                  className={cx(
                    `fa-regular ${
                      user.terms ? "fa-circle-check" : "fa-circle"
                    }`,
                  )}
                  onClick={() =>
                    setUser((prev) => ({
                      ...prev,
                      terms: !prev.terms,
                    }))
                  }
                />
                <span>I agree to&nbsp;</span>
                <a
                  href="https://app.paperflite.com/terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  terms and conditions
                </a>
              </div>
              {error.terms && (
                <p className={styles.error}>
                  <i className="paperflite-danger"></i>
                  <label>{error.terms}</label>
                </p>
              )}
              <span onClick={handleSubmit}>
                <Button
                  className={styles.button}
                  variant="primary"
                  icon="paperflite-right-arrow"
                  disabled={loading}
                >
                  {loading
                    ? "Activating your account"
                    : "Activate your account"}
                </Button>
              </span>
            </form>
          )}
        </>
      )}
      {invitationLoading && <p className={styles.loading}>Loading...</p>}
    </div>
  );
}

export default AcceptInvitation;
